import script from "./BaseVuexSearchItem.vue?vue&type=script&lang=js"
export * from "./BaseVuexSearchItem.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__